import { render, staticRenderFns } from "./BillReceivebleHistoricChart.vue?vue&type=template&id=a749320a"
import script from "./BillReceivebleHistoricChart.vue?vue&type=script&lang=js"
export * from "./BillReceivebleHistoricChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports